import React from 'react';
import { Project } from '../types';

interface Props {
  project: Project;
  flag: keyof Project;
  children: React.ReactNode;
}

/**
 * Renders children if the named module flag on Project is truthy. Otherwise shows
 * a centered "module not enabled" empty state.
 */
export default function ModuleGuard({ project, flag, children }: Props) {
  if (project[flag]) return <>{children}</>;

  return (
    <div style={{
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      padding: '80px 24px', minHeight: 320,
      fontFamily: 'var(--font-ui)',
    }}>
      <svg width={32} height={32} viewBox="0 0 24 24" fill="none" stroke="#B8BEC9" strokeWidth={1.5}>
        <rect x={5} y={11} width={14} height={9} rx={2} />
        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
      </svg>
      <div style={{ marginTop: 12, fontSize: 15, fontWeight: 500, color: '#5A6272' }}>
        This module is not enabled for this project.
      </div>
      <div style={{ marginTop: 4, fontSize: 13, color: '#9198A8' }}>
        Enable it in Project Settings to get started.
      </div>
    </div>
  );
}
